import ServiceCenterAdminTypes from 'store/actionTypes/serviceCenterAdmin'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  systems: [],
  current: {},
  pagination: {},
  filter: {},
  portalRole: {}
}

const serviceCenterAdmin = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case ServiceCenterAdminTypes.GET_SERVICE_CENTER_ADMINS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case ServiceCenterAdminTypes.GET_SERVICE_CENTER_ADMIN_PORTAL_ROLE_SUCCESS:
      return { ...state, portalRole: payload?.portalRole }
    case ServiceCenterAdminTypes.GET_SERVICE_CENTER_ADMIN_DETAIL_SUCCESS:
      return { ...state, current: payload?.userCompany }
    case ServiceCenterAdminTypes.UPDATE_FILTER_SERVICE_CENTER_ADMIN_SUCCESS:
      return { ...state, filter: payload }
    case ServiceCenterAdminTypes.CLEAR_FILTER_SERVICE_CENTER_ADMIN_SUCCESS:
      return { ...state, filter: initialData.filter }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default serviceCenterAdmin
